module.exports = veItemCatalogMfeConfig;